import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  name: 'cargo',
  data() {
    return {
    };
  },
  created() {
    this.getConfigList('page_list');
  },

  methods: {

  },
};
